import { IoBanSharp } from "react-icons/io5";
import { HiArrowTrendingUp, HiArrowTrendingDown } from "react-icons/hi2";
import { ReactNode } from "react";

interface StatCardProps {
  title: string;
  value: string;
  change: string;
  changeType: 'up' | 'down';
  color: string;
  icon: ReactNode;
}

export const StatCard: React.FC<StatCardProps> = ({ title, value, change, changeType, color, icon }) => {
  const changeColor = changeType === 'up' ? 'text-green-500' : 'text-red-500';
  const changeSymbol = changeType === 'up' ? <HiArrowTrendingUp /> : <HiArrowTrendingDown />;

  return (
    <div className="bg-white rounded-md border border-slate-200 px-4 py-3 w-full">
      <div className="flex justify-between items-center">
        <div className="flex flex-col gap-2">
          <div className="flex items-center space-x-4">
            <div className="text-[12px] font-semibold">{title}</div>
          </div>
          <div className="text-xl font-bold">{value}</div>
          <div className={`flex gap-2 ${changeColor}`}>
            <div className="flex justify-start items-center">
              {changeSymbol}
            </div>
            <div className={`text-xs`}> {change}% <span className="text-slate-600">Last 30 days users</span></div>
          </div>
        </div>
        <div className="bg-green-50 border border-green-300 text-green-600 w-9 h-9 rounded-full flex justify-center items-center">
          {icon}
        </div>
      </div>
    </div>
  );
};